export const domain = 'https://knjigovodstvo.amplius.tech/anto/'
